import ApplicationAdapter from './application';

class SiteConfigAdapter extends ApplicationAdapter {
  pathForType() {
    return 'admin/site-config';
  }
}

export default SiteConfigAdapter;
